import { render, staticRenderFns } from "./DeleteRecordDetail.vue?vue&type=template&id=2ef950a8&scoped=true&"
import script from "./DeleteRecordDetail.vue?vue&type=script&lang=js&"
export * from "./DeleteRecordDetail.vue?vue&type=script&lang=js&"
import style0 from "../student/update-request-detail.css?vue&type=style&index=0&id=2ef950a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef950a8",
  null
  
)

export default component.exports